<template>
    <div class="partner-resource container" id="partner-resources-vue" v-if="hasPermission">
        <p class="filepath">
            <a href="#" @click="onClickAll()">{{i18n.all}}</a> <i class="icon-ksd-arrow_right"></i> {{currentFolder}}
        </p>
        <!-- pc 端 begin -->
        <div class="fileTable">
            <div class="row trHead">
                <div class="col-7 th">{{i18n.file_name}}</div>
                <div class="col-3 th">{{i18n.last_modified}}</div>
                <div class="col-1 th">{{i18n.file_size}}</div>
                <div class="col-1 th">{{i18n.operation}}</div>
            </div>
            <div class="row tbody" v-for="file in fileList" :key="file.fileName">
                <div :class="{'col-7': true, td: true, title: true, clickable: file.folder}" @click="onItemClick(file)">
                    <div class="overflow">
                        <p><i :class="{'icon-ksd-file': file.fileSize, 'icon-ksd-folder': file.folder}"></i>{{file.fileName}}</p>
                    </div>
                </div>
                <div class="col-3 td"><p>{{formatLastModified(file.fileLastModified)}}</p></div>
                <div class="col-1 td"><p>{{formatFileSize(file.fileSize)}}</p></div>
                <div class="col-1 td" v-if="file.fileSize"><p><a :href="file.webURL" class="download" target="_blank" v-if="file.webURL"><i class="icon-ksd-download"></i></a></p></div>
                <div class="col-1 td" v-else><p><a href="#" @click="onItemClick(file)"><i class="icon-ksd-arrow_right"></i></a></p></div>
            </div>
        </div>
        <!-- pc 端 end -->
        <!-- 移动 端 begin -->
        <ul class="fileList">
            <li v-for="file in fileList" :key="file.fileName" @click="onItemClick(file)" :class="{clickable: file.folder}">
                <div class="titleBox">
                    <p class="title"><i :class="{'icon-ksd-file': file.fileSize, 'icon-ksd-folder': file.folder}"></i> {{file.fileName}}</p>
                    <p v-if="file.fileSize">{{formatFileSize(file.fileSize)}} | {{formatLastModified(file.fileLastModified)}}</p>
                    <p v-else>{{formatLastModified(file.fileLastModified)}}</p>
                </div>
                <p class="oper" v-if="file.fileSize"><a :href="file.webURL" ><i class="icon-ksd-download"></i></a></p>
                <p class="oper" v-else><a :href="file.webURL" ><i class="icon-ksd-arrow_right"></i></a></p>
            </li>
        </ul>
        <!-- 移动 端 end -->
    </div>
    <div class="partner-resource container no-permission" v-else>
        <div class="row">
            <div class="col-12 image"></div>
        </div>
        <div class="row" style="text-align: center">
            <div class="col-12">
                <p>{{i18n.no_permission_msg}} <a :href="homepage">{{i18n.back_to_homepage}}</a> </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { lang, list, tr } from './handler';
    import * as moment from 'moment';

    @Component
    export default class PartnerResourceList extends Vue {
        fileList = list;
        i18n = tr;
        currentFolder = '';

        get homepage() {
            if (lang === 'en') {
                return '/'
            } else {
                return '/zh/'
            }
        }

        get hasPermission() {
            return list.length > 0
        }

        formatLastModified(timestamp) {
            moment.locale(document.documentElement.lang);
            return timestamp ? moment.unix(timestamp).format('LL') : '';
        }

        formatFileSize(size) {
            return size ? Math.ceil(parseInt(size) / 1024 / 1024) + 'M' : '';
        }

        onItemClick(item) {
            if (item.folder) {
                this.currentFolder = item.fileName
                this.fileList = item.folder
            }
        }

        onClickAll() {
            this.currentFolder = ''
            this.fileList = list
        }
    }
</script>



// WEBPACK FOOTER //
// App/components/PartnerResources/PartnerResources.vue